function r(n) {
  if (n.length === 1)
    return n[0];
  let t = 0, a = 0, e = 0;
  for (const c of n) {
    const l = c.latitude * Math.PI / 180, h = c.longitude * Math.PI / 180;
    t += Math.cos(l) * Math.cos(h), a += Math.cos(l) * Math.sin(h), e += Math.sin(l);
  }
  const o = n.length;
  t /= o, a /= o, e /= o;
  const i = Math.atan2(a, t), u = Math.sqrt(t * t + a * a);
  return {
    latitude: Math.atan2(e, u) * 180 / Math.PI,
    longitude: i * 180 / Math.PI
  };
}
export {
  r as averageGeolocation
};
//# sourceMappingURL=map.js.map
